// import axios from 'axios'
import querystring from 'querystring'
import util from 'util'
import _ from 'lodash'
import store from '../../store'
import { vals } from '../../util'
import Promise from 'bluebird'
import { stat } from 'fs'
// load our config
const config = require('../../../config/settings')
const stringify = JSON.stringify
const parse = JSON.parse
// libraries need for some REST requests
import router from '../../main'
import api from '../../axios_api'

// linked in auth url
const LI_AUTH = 'https://www.linkedin.com/oauth/v2/authorization'

// initial state
const state = {
    id: '',
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    token: '',
    server_id: '',
    is_new: true,
    currency_pref: 'US_DOLLAR',
    linkedin: {},
    twitter: {},
    account_id: '',
    google: {},
    facebook: {},
    cognito: {},
    image: '',
    linked_in: {
        code: ''
    },
    workspace_id: '',
    ltse: {},
    s3Key: '',
    workspaceTypes: []
}

const buildFormData = function (payload) {
    let formData = new FormData();  /*
        Add the form data we need to submit
    */
    for (var i = 0; i < payload.files.length; i++) {
        let file = payload.files[i];

        if (!file) {
            file = new Blob(['test'], { type: "text/plain;charset=utf-8" });
        }

        formData.append(
            'files[' + i + ']',
            file,
            (file ? file.name : '')
        );
    }
    formData.append('encrypt', JSON.stringify({ encrypt: { data: payload.data } }));

    return formData;
}

// getters
// ref: getter sig = (state, getters, rootState)
const getters = {
    user: state => {
        return {
            id: state.id ? state.id : '', firstName: state.first_name ? state.first_name : state.firstName, lastName: state.last_name ? state.last_name : state.lastName, email: state.email, serverId: state.server_id ? state.server_id : state.uuid, linkedin: state.linkedin, token: state.token,
            twitter: state.twitter, image: state.image, google: state.google, facebook: state.facebook, account_id: state.account_id, cognito: state.cognito, ltse: state.ltse, s3Key: state.s3Key, workspaceTypes: state.workspaceTypes
        }
    },
    hasToken: state => {
        return !_.isNil(state.token) && !_.isEmpty(state.token)
    },
    workspace_id: state => {
        return state.workspace_id
    },
    token: state => {
        return state.token
    },
    id: state => {
        return state.id
    },
    account_id: state => {
        return state.account_id
    },
    isNew: state => {
        return state.is_new
    },
    currency: state => {
        return vals.CURRENCIES[state.currency_pref]
    }
}

// mutations - (also thought as 'setters')
const mutations = {
    user(state, payload) {
        payload = payload.user;
        state.id = payload.id || payload._id;
        state.token = payload.token || payload.encrypt.jwt || ''
        state.first_name = payload.first_name ? payload.first_name : payload.firstName
        state.last_name = payload.last_name ? payload.last_name : payload.lastName
        state.server_id = payload.uuid
        state.is_new = payload.newProfile ? payload.newProfile : payload.isNew;
        state.linkedin = payload.linkedin;
        state.ltse = payload.ltse;
        state.google = payload.google;
        state.facebook = payload.facebook;
        state.twitter = payload.twitter;
        state.image = payload.image;
        state.cognito = payload.cognito;
        state.workspace_id = payload.workspace_id;
        state.email = payload.email ? payload.email : ''
        state.account_id = payload.account_id;
        state.workspace_id = payload.workspace_id;
        state.s3Key = payload.s3Key ? payload.s3Key : '';
        state.workspaceTypes = payload.workspaceTypes ? payload.workspaceTypes : [];
        if (window && window.intercomSettings) {
            if (state.first_name && state.first_name.length > 0) {
                window.intercomSettings.name = `${state.first_name} ${state.last_name}`;
            }
            if (state.email && state.email.length > 0) {
                window.intercomSettings.email = `${state.email}`;
            }
            if (window.Intercom) {
                window.Intercom('update');
            }
        }
    },
    cognito(state, payload) {
        state.cognito = payload.cognito;
    },
    image(state, payload) {
        state.image = payload.image;
    },
    id(state, payload) {
        state.id = payload.id
    },
    google(state, payload) {
        state.google = payload.google;
    },
    linkedin(state, payload) {
        state.linkedin = payload.linkedin;
    },
    email(state, payload) {
        state.email = payload.email;
    },
    twitter(state, payload) {
        state.twitter = payload.twitter;
    },
    facebook(state, payload) {
        state.facebook = payload.facebook;
    },
    ltse(state, payload) {
        state.ltse = payload.ltse
    },
    account_id(state, payload) {
        state.account_id = payload.account_id
    },
    first_name(state, payload) {
        state.first_name = payload.first_name
    },
    last_name(state, payload) {
        state.last_name = payload.last_name
    },
    token(state, payload) {
        state.token = payload.token
    },
    workspace_id(state, payload) {
        state.workspace_id = payload.workspace_id
    },
    linkedInCode(state, payload) {
        state.linked_in.code = payload.code
    },
    s3Key(state, payload) {
        state.s3Key = payload.s3Key;
    },
    initialize(state) {
        state.first_name = '',
            state.id = '',
            state.last_name = '',
            state.email = '',
            state.password = '',
            state.token = '',
            state.server_id = '',
            state.is_new = true,
            state.currency_pref = 'US_DOLLAR',
            state.linkedin = {},
            state.google = {},
            state.cognito = {},
            state.twitter = {},
            state.facebook = {},
            state.image = '',
            state.workspace_id = '';
        state.ltse = {};
        state.s3Key = '';
        state.workspaceTypes= [];
        if (window && window.intercomSettings) {
            if (window.intercomSettings.name) {
                delete window.intercomSettings.name;
            }
            if (window.intercomSettings.email) {
                delete window.intercomSettings.email;
            }
            if (window.Intercom) {
                window.Intercom('update');
            }
        }
    },
    markNew(state, payload) {
        state.is_new = payload.newProfile
    },

}

// actions - controller-esque logic
const actions = {
    start({ dispatch }) {
        // want to refresh our login
        // dispatch('loginRefresh')
    },
    stop({ commit }) {
        // clean up
        commit('initialize')
    },
    cycle({ }) { },
    login({ commit }, user) { // unused for now
        return new Promise((resolve, reject) => {
            api.post('/public', { data: { 'encrypt': 'some-string', 'email': user.email, 'password': user.password } }, { params: { authEnabled: false } })
                .then(resp => {
                    resolve(resp)
                })
                .catch(err => {
                    console.log(`Error in public: ${err}`)
                    reject(err)
                })
        })
    },
    loginRefresh({ commit }) {
        // see if we still have a valid jwt token
        return new Promise((resolve, reject) => {
            api.get('/linkedin/auth')
                .then(resp => {
                    resolve(resp)
                })
                .catch(err => {
                    console.log(`Error in checking auth: ${err}`)
                    reject(err)
                })
        })
    },
    authorizeLI({ commit }) {
        return new Promise((resolve, reject) => {
            let data = {
                response_type: 'code',
                client_id: config.LI_API_KEY,
                redirect_uri: config.LI_REDIRECT,
                state: config.LI_STATE,
                scope: config.LI_SCOPE
            }
            console.log(`authorization data: ${JSON.stringify(data)}`)
            // need to set the window to open to linked in
            // cannot use REST request from front-end (purposefully blocked by LI via CORS)
            // cannot use REST request from back-end (no support in our current structure)
            let w = window.open(LI_AUTH + `?${querystring.encode(data)}`, '', 'width=800,height=600')
            if (!w) {
                alert('Please allow popups for this site in order to securely login to linked in.')
                reject({ err: 'no popup' })
                return
            }
            w.env = { WINDOW_TARGET: process.env.VUE_APP_WINDOW_TARGET }
            resolve()
            return
        })
    },
    apiConfirmLI({ commit }, code) { // for now not using this -- LinkedIn requires the redirect be the exact same as the request to get the code (stupid is as stupid does)
        return new Promise((resolve, reject) => {
            api.post('/linkedin/auth', { 'encrypt': { 'code': code } }, { params: { authEnabled: false } })
                .then(res => {
                    // assume success and write the code
                    commit('linkedInCode', code)
                    resolve(res.data)
                })
                .catch(err => {
                    console.log(`Error response from server (post li auth): ${util.inspect(err)}`)
                    reject(err)
                })
        })
    },
    apiGetProfile({ commit }, id) {
        return new Promise((resolve, reject) => {
            api.get(`/user/id/${id}`)
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    console.error(`Error response from /user/:id: ${err}`)
                    reject(err)
                })
        })
    },
    apiUploadUserData({ commit }, data) {
        return Promise.map(data, d => {
            _.forIn(d, (v, k, o) => {
                if (vals.PORTFOLIO_HEADERS.indexOf(k.toUpperCase()) < 0)
                    delete o[k]
            })
            return Promise.resolve(d)
        })
            .then(data => {
                return api.post('/user/company', { 'encrypt': { data } })
            })
    },
    apiFetchUserData({ commit }) {
        return new Promise((resolve, reject) => {
            api.get('/user/company')
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    console.error(`Error fetching user data: ${util.inspect(err)}`)
                    reject(err)
                })
        })
    },
    apiAddUser({ rootGetters }, payload) {
        let url = `/add-user`;
        return api.post(url, { encrypt: { data: payload } })
            .then(res => {
                return Promise.resolve(res.data.encrypt)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },

    apiDeleteUser({ commit }) {
        return new Promise((resolve, reject) => {
            let url = `${router.currentRoute.params.account_id}/user/clear`;
            api.delete(url)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    apiGetAllUsers({ commit }) {
        return new Promise((resolve, reject) => {
            if (router && router.currentRoute && router.currentRoute.params && router.currentRoute.params.account_id) {
                let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/getallUsers`;
                api.get(url)
                    .then(res => {
                        resolve(res)
                    })
                    .catch(err => {
                        reject(err)
                    })
            }
        })
    },
    apiPostAccountImage({ commit }, payload) {
        if (_.isNil(payload) || _.isEmpty(payload)) return Promise.reject({ error: 'no arguments' })
        let formData = buildFormData(payload);
        let url = `/accountProfileUpload`;
        return api.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                return Promise.resolve(res)
            })
            .catch(err => {
                console.error(`Error during account image upload: ${err}`)
                return Promise.reject(err)
            })
    }

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}